<div class="container" id="main-content" aria-label="Main Content">

    <div class="row" *ngIf="loadIssue">
        <div class="col-md-12">
            <p class="alert-danger" [innerHTML]="'COMMON.LOAD_ISSUE' | translate"></p>
        </div>
    </div>

    <div *ngIf="!loadIssue">
        <h1 class="heading-title" tabindex="0">{{ 'MAIN_PAGE.BREADCRUMBS.LOCATION' | translate}} </h1>

        <hr />


        <div class="vertical-line">

            <div *ngIf="globals.blLanguage == 0 && turnaroundInfoText" tabindex="-1" class="turnaround-extra-info"
                attr.aria-label="{{'turnaroundInfoText'}}" [innerHTML]="turnaroundInfoText | noSanitise">
            </div>

            <div *ngIf="globals.blLanguage == 1 && turnaroundInfoTextIrish" tabindex="-1" class="turnaround-extra-info"
                attr.aria-label="{{'turnaroundInfoTextIrish'}}" [innerHTML]="turnaroundInfoTextIrish | noSanitise">
            </div>

        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="1.5%" fxLayoutAlign="center" class="location-block">
            <mat-card class="location-card" *ngFor="let location of locationList; let i = index" fxFlex="40%;"
                fxFlex.xs="80%">
                <div class="mat-header">
                    <div *ngIf="location.address && location.address">
                        <leaflet-map [lat]="location.address.lat" [long]="location.address.long" [index]="i+1">
                        </leaflet-map>
                    </div>
                </div>
                <mat-card-content>
                    <h4 tabindex="0" class="card-title">{{location.name | translateSplit}}</h4>

                    <p *ngIf="location.description" tabindex="0" class="card-text"
                        [innerHTML]="location.description | translateSplit | noSanitise">
                    </p>

                    <!-- <div *ngFor="let service of location.filteredServices">
                        <div *ngIf="!location.notBookable">
                            <p class="card-text" tabindex="0">{{service.name | translateSplit}} </p>
                        </div>
                    </div> -->

                </mat-card-content>
                <div class="mat-footer">
                    <button class="btn btn-primary" mat-raised-button
                        [disabled]="location.filteredServices?.length === 0 || location.notBookable"
                        (click)="selectLocation(location);" tabindex="0">{{'COMMON.SELECT' | translate}}</button>
                </div>
                <div *ngIf="location.services?.length === 0; else appointmentsClosed">
                    <mat-error>
                        <p class="card-text" tabindex="0">{{'COMMON.CLOSED' | translate}} </p>
                    </mat-error>
                </div>
                <ng-template #appointmentsClosed>
                    <div *ngIf="location.notBookable">
                        <mat-error>
                            <p class="card-text" tabindex="0">{{'COMMON.APPOINTMENTS_CLOSED' | translate}} </p>
                        </mat-error>
                    </div>
                </ng-template>
            </mat-card>
        </div>

        <div *ngIf="globals.blLanguage == 0 && turnaroundText" tabindex="0" class="turnaround-extra"
            attr.aria-label="{{'turnaroundText'}}" [innerHTML]="turnaroundText | noSanitise"></div>

        <div *ngIf="globals.blLanguage == 1 && turnaroundText" tabindex="0" class="turnaround-extra"
            attr.aria-label="{{'turnaroundTextIrish'}}" [innerHTML]="turnaroundTextIrish | noSanitise"></div>

    </div>
</div>